import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { LOCAL_STORAGE_KEYS } from './local-storage.service';
import { App } from '@capacitor/app';
import { NativeCheckService } from './native-check.service';

@Injectable({
  providedIn: 'root'
})
export class RouteReloadService {
  public constructor(
    private router: Router,
    private nativeCheckService: NativeCheckService,
  ) {
    if(this.nativeCheckService.isNativePlatform()) {
      this.initCurrentRouteCaching();
    }
  }

  // to avoid capacitor issues with route restore redirecing always to router's default redirectTo
  private initCurrentRouteCaching(): void {
    // Save route on every navigation
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        Preferences.set({ key: LOCAL_STORAGE_KEYS.LAST_ACTIVE_ROUTE, value: event.url });
      }
    });

    // Restore route on app resume
    App.addListener('resume', async () => {
      const { value: lastRoute } = await Preferences.get({ key: LOCAL_STORAGE_KEYS.LAST_ACTIVE_ROUTE });
      if (lastRoute && lastRoute !== '/') {
        this.router.navigateByUrl(lastRoute);
      }

    });

    this.restoreLastRoute();
  }

  private async restoreLastRoute() {
    const { value: lastRoute } = await Preferences.get({ key: LOCAL_STORAGE_KEYS.LAST_ACTIVE_ROUTE });
    if (lastRoute && lastRoute !== '/' && this.router.url === '/') {
      this.router.navigateByUrl(lastRoute);
    }
  }

  public reloadCurrent(): void {
    const redirectRoute = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(redirectRoute ?? '/summary');
    });
  }
}
